export enum DevelopmentCostResponsibility {
  REQUESTORS_ORGANIZATION = "Requestor's Organization Responsible",
  PRODUCT_TEAM_COVERED = 'Product Team Covered',
  SHARED_RESPONSIBILITY = 'Shared Responsibility',
  NOT_APPLICABLE = 'Not Applicable',
  OTHER = 'Other',
}
